module.exports = __webpack_public_path__ + "static/media/PartnerDeliveryHeroLogo.154641f1.png";